var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"content-page",attrs:{"background":"","layout":"prev, pager, next","total":_vm.total},on:{"current-change":_vm.goTo}})
}
var staticRenderFns = []

export { render, staticRenderFns }